import { z } from 'zod';

export const TASK_STATUS = ['pendente', 'em_andamento', 'concluida', 'cancelada'] as const;
export type TaskStatus = (typeof TASK_STATUS)[number];

export const TASK_PRIORIDADES = ['baixa', 'media', 'alta'] as const;
export type TaskPrioridade = (typeof TASK_PRIORIDADES)[number];

export const STATUS_LABEL: Record<TaskStatus, string> = {
  pendente: 'Pendente',
  em_andamento: 'Em andamento',
  concluida: 'Concluída',
  cancelada: 'Cancelada',
};

export const PRIORIDADE_LABEL: Record<TaskPrioridade, string> = {
  baixa: 'Baixa',
  media: 'Média',
  alta: 'Alta',
};

export const taskSchema = z.object({
  id: z.coerce.number(),
  oportunidade_id: z.coerce.number(),
  parent_task_id: z.coerce.number().nullish(),
  titulo: z.string(),
  descricao: z.string().nullish(),
  responsavel_id: z.coerce.number().nullish(),
  responsavel_nome: z.string().nullish(),
  prazo_em: z.string().nullish(),
  status: z.enum(TASK_STATUS),
  prioridade: z.enum(TASK_PRIORIDADES).nullish(),
  criado_por: z.coerce.number().nullish(),
  criado_por_nome: z.string().nullish(),
  criada_em: z.string().nullish(),
  concluida_por: z.coerce.number().nullish(),
  concluida_por_nome: z.string().nullish(),
  concluida_em: z.string().nullish(),
  atualizado_em: z.string().nullish(),
});
export type Task = z.infer<typeof taskSchema>;

export const tasksListSchema = z.object({
  tasks: z.array(taskSchema).default([]),
});

export const taskMutationResponseSchema = z.object({
  task: taskSchema.optional(),
  ok: z.boolean().optional(),
  noop: z.boolean().optional(),
});

export interface TaskInput {
  titulo: string;
  descricao?: string | null;
  responsavel_id?: number | null;
  prazo_em?: string | null;
  prioridade?: TaskPrioridade | null;
  status?: TaskStatus;
  parent_task_id?: number | null;
}
